export const getProps = (size, index) => ({
  withMarginTop: !!index,
  withShadow: true,
  isLastItem: size - 1 === index
});